import api from "@/lib/api";

let snapPromise = null;

// Loads Midtrans Snap.js once, using the client key + url from our backend config
// (server key is never exposed). Safe to call multiple times.
export function loadSnap() {
  if (typeof window !== "undefined" && window.snap) return Promise.resolve();
  if (snapPromise) return snapPromise;
  snapPromise = api.get("/payment/config").then(({ data }) => new Promise((resolve, reject) => {
    if (window.snap) return resolve();
    const existing = document.getElementById("midtrans-snap");
    if (existing) { existing.addEventListener("load", () => resolve()); return; }
    const s = document.createElement("script");
    s.id = "midtrans-snap";
    s.src = data.snap_url;
    s.setAttribute("data-client-key", data.client_key || "");
    s.onload = () => resolve();
    s.onerror = () => { snapPromise = null; reject(new Error("Gagal memuat Snap.js")); };
    document.head.appendChild(s);
  }));
  return snapPromise;
}
